module.exports = __webpack_public_path__ + "static/img/Joe-Ingles.fcea5a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Joe-Ingles.jpg
// module id = 2RY3
// module chunks = 1